// Estado del botón Thinking para el payload de Web Chat.
// null = automático (no enviar channelData.thinking)
// true/false = enviar el valor explícito.

let thinking: boolean | null = null;

export const setThinking = (value: boolean | null) => {
  thinking = value;
};

export const getThinking = () => thinking;
